jQuery(document).ready(function($) {

	// Project images slider

	$('.js-project-slider').each( function() {

		var $slides = $( this );

		if ( $slides.find( '.js-project-image' ).length > 1 ) {

			var $slider = $slides.slick({
				slidesToShow: 1,
				swipeToSlide: true,
				arrows: false,
				lazyLoad: 'progressive'
				// focusOnSelect: true
				// mobileFirst: true,
				// responsive: [
				// 	{
				// 		breakpoint: 640,
				// 		settings: {
				// 			slidesToShow: 3
				// 		}
				// 	}
				// ]
			});

			// Advance slides on click (based on https://github.com/kenwheeler/slick/issues/996)
			$slider.on( 'click' , function(){
			   $slider.slick( 'slickNext' );
			});

		} // End if
	});

});